import React from 'react';

/** 404-Seite für unbekannte URLs (M3). */
export function NotFoundView({ onNavigate }) {
  const goTo = (path) => (event) => {
    event.preventDefault();
    if (onNavigate) onNavigate(path);
  };
  return (
    <section className="mx-auto max-w-[720px] px-4 py-16 text-center" data-testid="not-found-view">
      <p className="text-sm font-bold text-[var(--primary)]">Fehler 404</p>
      <h1 className="mt-2 font-display text-3xl font-bold text-[var(--foreground)]">Seite nicht gefunden</h1>
      <p className="mt-3 text-sm text-[var(--secondary)]">
        Die aufgerufene Adresse existiert nicht oder wurde verschoben.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <a href="/" onClick={goTo('/')} className="rounded-lg bg-[var(--primary)] px-4 py-2 text-sm font-bold text-white">Zur Startseite</a>
        <a href="/catalog" onClick={goTo('/catalog')} className="rounded-lg border border-[var(--border)] px-4 py-2 text-sm font-bold text-[var(--foreground)]">Zum Sortiment</a>
      </div>
    </section>
  );
}
